import React, { createContext, useContext, useState, useEffect } from "react";
import userApi from "../api/UserApi"
import { notification } from "antd";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [userId, setUserId] = useState(null);
  const [loginError, setLoginError] = useState(0);

  const login = async (email, password) => {
    setLoginError(0);
    try {
      const response = await userApi.loginUser(email, password);

      if (response.status) {
        const userRole = response.data.permissionLevel;
        
        if (userRole !== 1) {
          notification.error({
            message: "Login Failed",
            description: "You do not have permission to access this system.",
          });
          return false;
        }

        notification.success({
          message: "Login Successful",
          description: "You have successfully logged in",
        });
        const userEmail = response.data.emailAddress
        
        let currentUserId = response.data.id || response.data.userId || response.data.user_id;
        
        if (!currentUserId) {
          try {
            const userDataResponse = await userApi.getAllUsers();
            if (userDataResponse.status && userDataResponse.data) {
              const currentUser = userDataResponse.data.find(user => user.emailAddress === userEmail);
              if (currentUser) {
                currentUserId = currentUser.id;
              }
            }
          } catch (error) {
            console.error("Error fetching user data for ID lookup:", error);
          }
        }
        localStorage.setItem("userRole", userRole);
        localStorage.setItem("userEmail", userEmail);
        localStorage.setItem("userId", currentUserId);

        setRole(userRole);
        setUserId(currentUserId);

        return true;
      } else {
        if (response.message === "unauthorized") {
         
          notification.error({
            message: "Login Failed",
            description: "Invalid email or password",
          });
        } else {
          notification.error({
            message: "Something went wrong please try again.",
            description: "An error occurred",
          });
        }
        return false;
      }
    } catch (error) {
      console.error("Login error:", error.response.data.status);
      setLoginError(error.response.data.status);
      return false;
    }
  };

  useEffect(() => {
    let localRole = localStorage.getItem("userRole");
    let localUserId = localStorage.getItem("userId");
  
    if (localRole != null && localRole !== 'null') {
        setRole(localRole);
        setUserId(localUserId);
    }
  }, []);

  const logout = () => {
    setRole(null);
    setUserId(null);
    localStorage.setItem("userRole", null);
    localStorage.setItem("userEmail", null);
    localStorage.setItem("userId", null);
    // window.location.href = 'login'
  };

  return (
    <AuthContext.Provider value={{ role, setRole, userId, setUserId, login, logout, loginError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
